export default "__VITE_ASSET__BvooFN7a__"